import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery, useApolloClient, useSubscription } from 'react-apollo';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import {
  GET_GROUP_CONVOS_SMS,
  GET_GROUP_SMS_CONVO,
  CREATE_CONVO,
} from 'graphql/conversations';
import Spin from 'components/common/Spin';
import Button from 'components/common/Button';
import Conversation from '../components/Conversation';
import { getFullName } from 'utils';
import useSnack from 'hooks/useSnack';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > .MuiCard-root': {
      boxShadow: 'none',
      height: 'calc(100vh - 180px)',
    },

    '& .MuiCardHeader-avatar': {
      display: 'none',
    },
    '& .MuiCardHeader-title': {
      display: 'none',
    },
  },
  unreadLabel: {
    color: theme.palette.text.primary,
    fontWeight: 600,
  },
  tabs: {
    borderBottom: '1px solid #eee',
  },
}));

const GroupRooms = ({ match, history }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const { data, loading } = useSubscription(GET_GROUP_CONVOS_SMS, {
    variables: {
      groupId: match.params.groupId,
    },
  });

  if (loading) return <Spin spinning linear />;

  return (
    <Box>
      <Card className={classes.paper}>
        <Box className={classes.root}>
          <Conversation
            user={user}
            history={history}
            match={{
              params: {
                id: data.group.conversation.id,
                type: 'sms',
              },
            }}
          />
        </Box>
      </Card>
    </Box>
  );
};

export default GroupRooms;
